var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 18,
    viewBox: "0 0 31 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3296 7.37513C29.2454 7.36147 29.1603 7.35517 29.0751 7.35628H4.56637L4.88273 7.20913C5.19197 7.06276 5.47329 6.86356 5.71411 6.62055L9.78271 2.55195C10.3186 2.04043 10.4086 1.21756 9.99607 0.602259C9.51596 -0.0534106 8.59524 -0.195781 7.93952 0.284329C7.88655 0.323139 7.8362 0.365449 7.78888 0.410969L0.431563 7.76829C-0.143407 8.34262 -0.143917 9.27429 0.430413 9.84926L0.431563 9.85041L7.78888 17.2077C8.36431 17.7815 9.29598 17.7803 9.86985 17.2048C9.91501 17.1595 9.95717 17.1113 9.99607 17.0606C10.4086 16.4453 10.3186 15.6224 9.78271 15.1109L5.72147 11.0349C5.50558 10.8188 5.25736 10.6376 4.98574 10.4979L4.5443 10.2992H28.9941C29.7458 10.3271 30.4053 9.80204 30.5465 9.06318C30.6766 8.261 30.1318 7.50526 29.3296 7.37513Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.cf95aa34843996321b86f44ed9b999c9.svg";
export { ForwardRef as ReactComponent };